import { render } from "./ReturnPackageComponent.vue?vue&type=template&id=0d2fdcc7&scoped=true"
import script from "./ReturnPackageComponent.vue?vue&type=script&lang=js"
export * from "./ReturnPackageComponent.vue?vue&type=script&lang=js"

import "./ReturnPackageComponent.vue?vue&type=style&index=0&id=0d2fdcc7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2fdcc7"]])

export default __exports__